export const TENANT_KEY = "TENANT";
export const UPDATE_TENANTS = "UPDATE_TENANTS";
export const ALTERAR_TENANT_ATUAL = "ALTERAR_TENANT_ATUAL";
